import { render, staticRenderFns } from "./GiftForm.vue?vue&type=template&id=137cbb50"
import script from "./GiftForm.vue?vue&type=script&lang=js"
export * from "./GiftForm.vue?vue&type=script&lang=js"
import style0 from "./GiftForm.vue?vue&type=style&index=0&id=137cbb50&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports